var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 430,
    viewBox: "0 0 290 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_2759)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1439_2759)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C10.7157 0 4 6.71574 4 15V415C4 423.284 10.7157 430 19 430H279C287.284 430 294 423.284 294 415V15C294 6.71573 287.284 0 279 0H19ZM37 18C28.7157 18 22 24.7157 22 33V257C22 265.284 28.7157 272 37 272H261C269.284 272 276 265.284 276 257V33C276 24.7157 269.284 18 261 18H37Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.997 387H95.2773C93.0682 387 91.2773 388.791 91.2773 391C91.2773 393.209 93.0682 395 95.2773 395H240.997C243.206 395 244.997 393.209 244.997 391C244.997 388.791 243.206 387 240.997 387Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6602 390.999C49.6602 388.79 51.4506 387 53.6593 387H118.181V394.998H53.6593C51.4506 394.998 49.6602 393.208 49.6602 390.999Z",
    fill: "#7B7B7B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2011 382.001C33.1523 382.001 33.1043 382.005 33.0563 382.014C30.6579 382.433 28.4562 383.765 27.0151 385.666H25.9987C23.7938 385.666 22 387.375 22 389.475V392.526C22 394.627 23.7938 396.336 25.9987 396.336H27.0151C28.4538 398.235 30.6555 399.566 33.0555 399.988C33.2906 400.028 33.5306 399.969 33.7121 399.824C33.8952 399.679 34 399.465 34 399.238V382.762C34 382.536 33.8944 382.321 33.7121 382.176C33.5673 382.061 33.3866 382 33.2003 382L33.2011 382.001Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.943 396.961C273.797 397.091 273.606 397.161 273.41 397.155C273.214 397.149 273.028 397.069 272.89 396.93C272.752 396.791 272.672 396.605 272.666 396.409C272.661 396.213 272.731 396.023 272.862 395.877C274.139 394.597 274.856 392.862 274.856 391.053C274.856 389.245 274.139 387.51 272.862 386.229C272.784 386.16 272.721 386.075 272.677 385.981C272.633 385.886 272.609 385.784 272.606 385.68C272.603 385.575 272.621 385.472 272.659 385.375C272.698 385.278 272.756 385.19 272.829 385.116C272.903 385.042 272.991 384.984 273.088 384.945C273.184 384.907 273.288 384.888 273.392 384.891C273.497 384.894 273.599 384.918 273.694 384.961C273.788 385.005 273.873 385.068 273.943 385.145C275.507 386.713 276.386 388.838 276.386 391.053C276.386 393.268 275.507 395.393 273.943 396.961Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.869 394.661C271.798 394.734 271.713 394.792 271.62 394.832C271.526 394.872 271.426 394.894 271.324 394.895C271.222 394.895 271.121 394.876 271.027 394.837C270.933 394.799 270.847 394.742 270.775 394.67C270.703 394.598 270.646 394.512 270.608 394.418C270.569 394.324 270.55 394.223 270.551 394.121C270.552 394.02 270.573 393.919 270.613 393.825C270.653 393.732 270.712 393.647 270.785 393.577C271.453 392.906 271.828 391.999 271.828 391.052C271.828 390.106 271.453 389.198 270.785 388.528C270.712 388.457 270.653 388.373 270.613 388.279C270.573 388.186 270.552 388.085 270.551 387.983C270.55 387.882 270.569 387.781 270.608 387.686C270.646 387.592 270.703 387.507 270.775 387.435C270.847 387.363 270.933 387.306 271.027 387.267C271.121 387.229 271.222 387.209 271.324 387.21C271.426 387.211 271.526 387.232 271.62 387.272C271.713 387.313 271.798 387.371 271.869 387.444C272.824 388.402 273.361 389.7 273.361 391.052C273.361 392.405 272.824 393.703 271.869 394.661Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.593 400.092C266.264 399.655 264.192 398.34 262.805 396.419H261.833C260.817 396.418 259.842 396.013 259.124 395.295C258.405 394.576 258.001 393.602 258 392.586V389.519C258.001 388.503 258.405 387.53 259.124 386.811C259.842 386.092 260.817 385.688 261.833 385.687H262.805C264.192 383.765 266.264 382.45 268.593 382.013C268.703 381.993 268.817 381.996 268.926 382.024C269.035 382.053 269.136 382.106 269.222 382.178C269.308 382.25 269.378 382.34 269.426 382.441C269.473 382.543 269.498 382.654 269.498 382.767V399.338C269.498 399.451 269.473 399.563 269.426 399.664C269.378 399.766 269.308 399.856 269.222 399.928C269.136 400 269.035 400.051 268.926 400.079C268.817 400.108 268.703 400.112 268.593 400.092Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.871 347.098C166.871 345.943 166.871 343.057 164.871 341.902L143.121 329.345C141.121 328.19 138.621 329.633 138.621 331.943V357.057C138.621 359.367 141.121 360.81 143.121 359.655L164.871 347.098Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.559 345.803C202.811 345.08 202.811 343.274 201.559 342.551L190.234 336.013C188.983 335.29 187.418 336.194 187.418 337.639V350.715C187.418 352.161 188.983 353.064 190.234 352.341L201.559 345.803Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93 345.803C218.182 345.08 218.182 343.274 216.93 342.551L205.605 336.013C204.354 335.29 202.789 336.194 202.789 337.639V350.715C202.789 352.161 204.354 353.064 205.605 352.341L216.93 345.803Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1886 345.803C94.9371 345.08 94.9371 343.274 96.1886 342.551L107.514 336.013C108.765 335.29 110.33 336.194 110.33 337.639V350.715C110.33 352.161 108.765 353.064 107.514 352.341L96.1886 345.803Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8175 345.803C79.566 345.08 79.566 343.274 80.8175 342.551L92.1423 336.013C93.3938 335.29 94.9582 336.194 94.9582 337.639V350.715C94.9582 352.161 93.3938 353.064 92.1423 352.341L80.8175 345.803Z",
    fill: "#898989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1439_2759",
    x: 0,
    y: 0,
    width: 298,
    height: 438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1439_2759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1439_2759",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_2759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 438,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout3);
export default __webpack_public_path__ + "static/media/layout3.f29d0b57182af162d9947589f65d3b40.svg";
export { ForwardRef as ReactComponent };